import React, { useState } from "react";
import { ChevronDown, ExternalLink } from "lucide-react";
import { DebateSource } from "../utils/sources";

export function SourceRows({ sources }: { sources: DebateSource[] }) {
  return (
    <ul className="divide-y divide-line border-y border-line">
      {sources.map((source) => (
        <li key={source.id}>
          <a
            href={source.url}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="group block rounded-sm py-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-focus"
          >
            <span className="flex items-start gap-1.5 text-label font-medium leading-5 text-content group-hover:text-accent group-hover:underline">
              <span className="min-w-0 break-words">{source.title}</span>
              <ExternalLink aria-hidden="true" className="mt-0.5 h-3.5 w-3.5 shrink-0 text-muted group-hover:text-accent" />
              <span className="sr-only">(opens in a new tab)</span>
            </span>
            <span className="block break-words text-xs leading-5 text-muted">
              {source.domain}
              {source.check === "ok" && " · Link checked"}
            </span>
          </a>
        </li>
      ))}
    </ul>
  );
}

/** A "Sources (n)" button with the links underneath. Renders nothing with no sources. */
export default function SourcesDisclosure({
  sources,
  label = "Sources",
  className = "",
}: {
  sources: DebateSource[];
  label?: string;
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  if (sources.length === 0) return null;
  return (
    <div className={className}>
      <button type="button" className="thread-text-button" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        <ChevronDown aria-hidden="true" className={`h-3.5 w-3.5 transition-transform duration-150 ${open ? "" : "-rotate-90"}`} />
        <span className="tabular-nums">
          {label} ({sources.length})
        </span>
      </button>
      {open && (
        <div className="motion-fade mt-1.5">
          <SourceRows sources={sources} />
        </div>
      )}
    </div>
  );
}
